import React from 'react'

import { HomePage } from '#/components'

export const Page = () => <HomePage />
